import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

export const LinearBar = ({ width, total, amount }) => {
  const overflow = total - amount < 0;
  let percentage = overflow ? 100 : 0;

  if (total && amount) {
    percentage = (amount / total) * 100;
  }

  return (
    <BarContainer>
      <BarFill $percentage={overflow ? 100 : percentage} $overflow={overflow} />
    </BarContainer>
  );
};

LinearBar.defaultProps = {
  width: '100%',
  total: 0,
  amount: 0,
};

LinearBar.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const fillAnimation = keyframes`
  from { width: 0; }
  to { width: var(--percentage); }
`;

const BarContainer = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 6px;
  background-color: #e6e6e6;
  overflow: hidden;
`;

const BarFill = styled.div`
  --percentage: ${({ $percentage }) => $percentage}%;
  width: var(--percentage);
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primary.main};
  border-radius: 6px;
  animation: ${fillAnimation} 0.3s ease-out forwards;
`;
